import { concat, get, getOr, map, find, without } from 'lodash/fp';
import {
    MESSAGE_ADDED,
    MESSAGE_DRAFT_UPDATED,
    MESSAGE_UPDATED,
    MESSAGE_REMOVED,
    MESSAGES_FETCHING,
    THREAD_POSTED,
    THREAD_REMOVED,
    THREAD_DRAFT_REMOVED,
} from '../actionTypes';
import { loadingIds } from './utils';

export const loadingMessages = loadingIds(MESSAGES_FETCHING);

export function messages(state = {}, action: $TSFixMe) {
    switch (action.type) {
        case MESSAGE_ADDED:
            return {
                ...state,
                [action.payload.threadId]: concat(getOr([], action.payload.threadId)(state))(action.payload.message),
            };
        case MESSAGE_UPDATED:
            return {
                ...state,
                [action.payload.threadId]: map(
                    (item) =>
                        // @ts-expect-error $TSFixMeError: Spread types may only be created from object types.
                        (item as $TSFixMe).id === action.payload.messageId ? { ...item, ...action.payload.data } : item
                    // @ts-expect-error $TSFixMeError: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{}'.
                )(state[action.payload.threadId]),
            };
        case THREAD_POSTED:
            return {
                ...state,
                [action.payload.newThreadId]: get(action.payload.oldThreadId, state),
            };
        case MESSAGE_REMOVED: {
            // @ts-expect-error $TSFixMeError: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{}'.
            const messagesArray = state[action.payload.threadId];
            const messageToRemove = find(['id', action.payload.messageId])(messagesArray);

            return {
                ...state,
                [action.payload.threadId]: without([messageToRemove], messagesArray),
            };
        }
        case THREAD_REMOVED: {
            // @ts-expect-error $TSFixMeError: Type 'any' cannot be used as an index type.
            const { [action.payload.id]: draftThread, ...other } = state;
            return { ...other };
        }
        default:
            return state;
    }
}

export function drafts(state = {}, action: $TSFixMe) {
    switch (action.type) {
        case MESSAGE_DRAFT_UPDATED:
            return { ...state, [action.payload.threadId]: action.payload.text };
        case THREAD_POSTED:
            return {
                ...state,
                [action.payload.newThreadId]: get(action.payload.oldThreadId, state),
            };
        case THREAD_DRAFT_REMOVED:
            return { ...state, [action.payload.id]: '' };
        default:
            return state;
    }
}
